import { atom } from "recoil";

export const routeAtom = atom({
    key: 'routeAtom',
    default: ''
})
